// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NEnFN","field":"styles_field__3U-vR","fieldCol":"styles_fieldCol__-I8-i","diffCol":"styles_diffCol__zKVc5","diff":"styles_diff__1d-uK"};